<template>
  <!-- 下拉选择 -->
  <div class="SelectBox">
    <div v-if="!data.answered">
      <!-- 问题部分 -->
      <div class="SelectBox_title">
        <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
        <!-- <span class="span" v-if="data.rule">（字数不得超过{{data.rule.length}}字）</span> -->
      </div>
      <!-- 选项部分 -->
      <div class="box" :title="selectedLabel">
        <el-select
          ref="select"
          v-model="value"
          placeholder="请选择"
          popper-class="topic-select-box-dropdown">
          <el-option
            v-for="item in data.itemList"
            :key="item.itemNo"
            :label="labelTxt(item.itemDes)"
            :value="item.itemId"
            :title="labelTxt(item.itemDes)">
            <div v-for="o in JSON.parse(item.itemDes)" :key="JSON.stringify(o)">
              <span>{{o.txt}}</span>
            </div>
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- 有答案后 -->
    <div v-else>
      <!-- 问题部分 -->
      <div class="SelectBox_title">
        <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
        <!-- <span class="span" v-if="data.rule">（字数不得超过{{data.rule.length}}字）</span> -->
      </div>
      <!-- 选项部分 -->
      <div class="box" :title="selectedLabel">
        <el-select
          ref="select"
          v-model="value"
          :disabled="disabledBol"
          placeholder="请选择"
          popper-class="topic-select-box-dropdown"
          @visible-change="onVisibleChange">
          <el-option
            v-for="item in data.itemList"
            :key="item.itemNo"
            :label="labelTxt(item.itemDes)"
            :value="item.itemId"
            :title="labelTxt(item.itemDes)">
            <div v-for="o in JSON.parse(item.itemDes)" :key="JSON.stringify(o)">
              <span>{{o.txt}}</span>
            </div>
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
  </div>
</template>

<script>
const SELECT_WIDTH = 352
const DROPDOWN_MAX_WIDTH = 704

export default {
  name: 'SelectBox',
  props: {
    data: Object,
    disabledBol: Boolean     // 是否disabled
  },
  computed: {
    answerObj () {
      let obj
      if (!this.value) {
        obj = {
          msg: '请选择后提交'
        }
      } else {
        obj = {
          questionId: this.data.questionId,
          item: this.value
        }
      }
      return obj
    },
    // 选中项完整文案，用于输入框 hover 查看
    selectedLabel () {
      if (!this.value || !this.data || !this.data.itemList) return ''
      const matched = this.data.itemList.find(item => item.itemId === this.value)
      return matched ? this.labelTxt(matched.itemDes) : ''
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    // 处理选项文字
    labelTxt (val) {
      try {
        let arr = JSON.parse(val)
        return (arr && arr[0] && arr[0].txt) || ''
      } catch (e) {
        return ''
      }
    },
    // 初始化
    init () {
      if (this.data.answered) {
        this.value = this.data.answered
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SelectBox{
  .SelectBox_title{
    margin-top: 24px;
    font-size: 16px;
    line-height: 22px;
  }
  .box{
    width: 352px;
    margin-top: 8px;
    /deep/ .el-input__inner {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
/* 下拉选择框宽度 */
.el-select-dropdown__list{
  max-width: 600px;
}
/* 下拉选择框选项宽度 */
.el-select-dropdown__item{
  max-width: 600px;
  height: fit-content;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/select-box.vue